import PropTypes from 'prop-types';
import React from 'react'
import reactCSS from 'reactcss'

import { Popover, PopoverTrigger, PopoverContent, ColorPickerInputGroup } from 'twyne-new.ui'

const PARSERS = {
  default: {
    load(value) {
      if (value && value.includes(",")) {
        const values = value.split(",")
        const color = {
          r: `${values[0]}`,
          g: `${values[1]}`,
          b: `${values[2]}`,
          a: `${values[3]}`,
        }
        return color
      }
    },
    parse({ r, g, b, a }) {
      return `${r},${g},${b},${a}`
    },
  },
  css: {
    mask: /rgba\((\d+),(\d+),(\d+),(\d+)\)/,
    load(value) {
      if (this.mask.test(value)) {
        return PARSERS.default.load(value.replace(this.mask, '$1,$2,$3,$4'))
      }
    },
    parse({ r, g, b, a }) {
      return `rgba(${r},${g},${b},${a})`
    },
  },
}

class ColorPicker extends React.Component {
  static get parsers() {
    return PARSERS
  }

  state = {
    displayColorPicker: false,
    color: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  };

  componentWillMount() {
    const color = this.props.parser.load(this.props.value)
    if (color) {
      this.setState({ color })
    }
  }
  componentWillReceiveProps({ value }) {
    const color = this.props.parser.load(value)
    if (color) {
      this.setState({ color })
    }
  }

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChange = color => {
    this.setState(
      { color },
      () => this.props.onChange(this.props.parser.parse(this.state.color)),
    )
  };

  render() {
    const styles = reactCSS({
      default: {
        color: {
          borderRadius: '2px',
          background: `rgba(${this.state.color.r}, ${this.state.color.g}, ${this.state.color.b}, ${this.state.color.a})`,
        },
        swatch: {
          padding: '5px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '999',
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    return (
      <Popover>
        <PopoverTrigger asChild>
          <div className='w-10 h-10 border rounded-xs twy-border-base p-1 flex items-center justify-center'>
            <div style={styles.color} className='w-8 h-8 rounded-xs cursor-pointer'>
            </div>
          </div>
        </PopoverTrigger>
        <PopoverContent className='w-full p-0'>
          <ColorPickerInputGroup
            value={{ rgba: this.state.color }}
            onChange={color => this.handleChange(color?.rgba)}
            components={['picker']}
          />
        </PopoverContent>
      </Popover>
    )
  }
}

ColorPicker.propTypes = {
  id: PropTypes.string,
  parser: PropTypes.object,
  value: PropTypes.string,
  onChange: PropTypes.func,
}

ColorPicker.defaultProps = {
  parser: ColorPicker.parsers.default,
}

export default ColorPicker
